
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitokonkan() {



  const cardData =
  {
    keyword: 'Mumbai to Konkan Cab Service',
    heading: 'AB Ghule Cabs: Mumbai to Konkan Cab Service',
    headingDescription: 'Experience the scenic beauty of Konkan with AB Ghule Cabs’ Mumbai to Konkan Cab Service. Whether you are heading for a beach vacation, exploring historical forts, or simply enjoying the lush green landscapes, our comfortable cabs will take you from Mumbai to Konkan in style and convenience. With our well-maintained vehicles and expert drivers, your journey will be safe, relaxing, and enjoyable. Konkan is approximately 180 km from Mumbai.',

    top: 'Top Places to Visit in Konkan with AB Ghule Cabs',

    topPlaces: [
        {
          title: "Alibaug",
          description: "Alibaug is a coastal town known for its pristine beaches and historic forts, making it a popular weekend getaway from Mumbai. The town is home to several scenic beaches, including Alibaug Beach, and Kolaba Fort, which is located just off the coast. Visitors can enjoy the beautiful sandy shores, explore the historic fort, and relax in the peaceful atmosphere of this coastal retreat."
        },
        {
          title: "Murud Janjira Fort",
          description: "Murud Janjira Fort is a historic sea fort located on an island off the coast of Murud. Surrounded by the Arabian Sea, this robust fort is an architectural marvel with stunning views of the surrounding waters. The fort is known for its impressive design and strategic location, making it a popular spot for history buffs and photography enthusiasts alike. A boat ride from Murud leads you to this island fortress, offering a sense of adventure and exploration."
        },
        {
          title: "Ganpatipule",
          description: "Ganpatipule is a serene destination in Konkan, famous for its pristine beach and the ancient Ganapati Temple. The temple, dedicated to Lord Ganesha, is set amidst lush greenery and offers a peaceful spiritual retreat. The adjacent beach is ideal for relaxation, and the destination is perfect for those seeking both spiritual solace and natural beauty. The combination of the beach and temple makes Ganpatipule a unique place for a spiritual getaway."
        },
        {
          title: "Kihim Beach",
          description: "Kihim Beach is known for its tranquil atmosphere and natural beauty, making it an ideal destination for a relaxing day by the sea. Surrounded by dense vegetation and offering a clean shoreline, it is perfect for sunbathing, long walks, and swimming. The peaceful ambiance of Kihim Beach makes it a quiet alternative to the more crowded beaches, ideal for those seeking solitude and a break from the hustle and bustle of city life."
        },
        {
          title: "Ratnagiri",
          description: "Ratnagiri, a historical and scenic town in Konkan, offers a perfect blend of history, nature, and culture. The town is known for its beautiful beaches, including Mandvi Beach, and the Ratnadurg Fort, which offers panoramic views of the Arabian Sea. The famous Ratnagiri Lighthouse is another popular attraction, offering stunning views of the coastline. Ratnagiri is an ideal destination for those interested in both history and natural beauty."
        },
        {
          title: "Tarkarli",
          description: "Tarkarli is a hidden gem in Konkan, famous for its crystal-clear waters and beautiful beaches. Known for water sports like scuba diving and snorkeling, it is a paradise for adventure seekers. The serene environment, along with the vibrant marine life, makes Tarkarli a perfect spot for both relaxation and adventure. Whether you are a seasoned diver or a beginner, Tarkarli offers an unforgettable experience in the lap of nature."
        },
        {
          title: "Sindhudurg Fort",
          description: "Sindhudurg Fort, one of the most significant sea forts of the Maratha Empire, is located on an island off the coast of Malvan. The fort, which offers fascinating insights into the history of the Maratha rulers, is known for its robust architecture and strategic positioning. A boat ride from Malvan takes visitors to the fort, which provides panoramic views of the Arabian Sea and the surrounding landscapes. It’s a must-visit for history enthusiasts and adventure seekers."
        },
        {
          title: "Dapoli",
          description: "Dapoli is a serene coastal destination in Konkan, known for its scenic beaches and green hills. The town offers a variety of beaches like Ladghar and Karde, where visitors can enjoy water sports, nature walks, and peaceful relaxation. The area is perfect for family vacations and those looking to explore the natural beauty of Konkan. With its lush surroundings and quiet atmosphere, Dapoli is an excellent place to escape from the crowds and enjoy a peaceful retreat."
        },
        {
          title: "Jaigad Fort",
          description: "Jaigad Fort is a coastal fort located on a hilltop, offering magnificent views of the Arabian Sea and the surrounding landscape. The fort is historically significant and provides a glimpse into the region's past. Its elevated position makes it an excellent spot for panoramic views and photography. Jaigad Fort is perfect for history buffs, nature lovers, and those looking for an off-the-beaten-path experience in Konkan."
        },
        {
          title: "Guhagar",
          description: "Guhagar is a pristine coastal town known for its untouched beaches and clear blue waters. The region is perfect for those seeking a quiet escape amidst nature. Guhagar's virgin beaches offer an idyllic setting for relaxation, while its temples and historical landmarks add cultural richness to the experience. With its tranquil ambiance, Guhagar is ideal for visitors who want to unwind, enjoy nature, and explore the spiritual heritage of the region."
        }
      ],


  services: [
    {
      "name": "Mumbai to Alibaug Cab",
      description: "AB Ghule Cabs provides reliable, affordable, and luxurious taxi services for your trip from Mumbai to Alibaug. Whether you're heading for a relaxing weekend getaway with friends or a family vacation, our cabs offer unparalleled comfort, convenience, and safety throughout your journey. Alibaug is known for its pristine beaches, historic forts, and scenic surroundings, making it a perfect destination for a quick escape from the hustle and bustle of the city. Our professional drivers ensure a smooth, enjoyable ride so you can start your vacation stress-free."
    },
    {
      "name": "Mumbai to Ratnagiri Cab Service",
      description: "Travel from Mumbai to Ratnagiri with AB Ghule Cabs and experience a safe, smooth, and comfortable journey. Ratnagiri is a picturesque coastal town, famous for its scenic beaches, historic forts, and delicious Alphonso mangoes. We offer well-maintained vehicles and professional drivers, ensuring a relaxing ride whether you're traveling for leisure or business. Our fleet is equipped to cater to various preferences, from standard cabs to premium options, to ensure a customized travel experience. Trust us for timely pickups, courteous service, and a memorable trip to Ratnagiri."
    },
    {
      "name": "Mumbai to Ganpatipule Taxi Fare",
      description: "Get affordable and transparent taxi fares from Mumbai to Ganpatipule with AB Ghule Cabs, offering value-for-money services for your journey. Whether you're planning a pilgrimage to the Ganpatipule temple or visiting the serene beaches, our pricing structure is clear and competitive. Enjoy the comfort of our well-maintained vehicles, driven by experienced and friendly drivers who prioritize your safety and comfort. Ganpatipule, with its lush greenery, calm beaches, and the famous Swayambhu Ganapati Temple, promises an unforgettable spiritual and scenic experience."
    },
    {
      "name": "Mumbai to Malvan Cab Service",
      description: "Book a cab from Mumbai to Malvan with AB Ghule Cabs for a comfortable, hassle-free, and scenic ride to one of Maharashtra's most serene coastal towns. Malvan is famous for its beautiful beaches, such as Tarkarli, and delicious seafood, particularly Malvani cuisine. Whether you're a nature enthusiast looking to explore the natural beauty of the region or a foodie seeking authentic seafood, we ensure your journey is smooth and enjoyable. Our professional drivers will guide you through the journey with local insights and ensure that you reach your destination relaxed and refreshed."
    },
    {
      "name": "Mumbai to Tarkarli Cab Booking Online",
      description: "Booking a cab from Mumbai to Tarkarli has never been easier with AB Ghule Cabs. Our online booking system makes the process quick and convenient, allowing you to secure your ride in just a few clicks. Tarkarli is a hidden gem known for its crystal-clear waters, water sports, and beautiful beaches. Whether you're planning to relax on the beach or indulge in water activities like snorkeling and scuba diving, our reliable and professional drivers will ensure a safe, smooth, and timely journey. Enjoy a stress-free trip with our prompt pickups and expert drivers."
    },
    {
      "name": "Mumbai to Raigad Cab Booking",
      description: "Travel to Raigad from Mumbai with AB Ghule Cabs, offering a comfortable, scenic ride to explore the historical wonders of Raigad Fort. Situated amidst the beautiful Sahyadri mountains, Raigad is known for its historical significance as the capital of Chhatrapati Shivaji Maharaj's kingdom. Whether you're visiting for historical exploration, photography, or just to enjoy the panoramic views of the region, our cabs offer a smooth and comfortable journey. Our drivers are well-versed with the routes, ensuring you have a safe, punctual, and enjoyable experience while traveling to this beautiful fort."
    },
    {
      "name": "Mumbai to Deoghar Cabs",
      description: "AB Ghule Cabs offers reliable, safe, and comfortable taxi services from Mumbai to Deoghar, a popular pilgrimage destination known for its Baba Baidyanath Temple. Whether you are visiting for religious purposes or just to explore the area's temples and culture, we provide well-maintained vehicles and experienced drivers to ensure your journey is smooth and comfortable. Our fleet includes both standard and luxury options to meet all your travel needs. We understand the importance of punctuality and comfort during your trip, so we guarantee a hassle-free experience with timely pickups and professional service."
    },
    {
      "name": "Mumbai to Sawantwadi Cab Booking",
      description: "For a smooth and comfortable ride from Mumbai to Sawantwadi, choose AB Ghule Cabs. This charming town in Maharashtra, known for its beautiful lakes, traditional wooden toys, and serene surroundings, is perfect for a relaxed trip. Our fleet of cars is ideal for both business and leisure travel. Whether you're visiting to explore local markets, enjoy the picturesque Sawantwadi Lake, or take in the town's natural beauty, our professional drivers ensure a pleasant and safe journey. Choose us for a reliable, affordable, and enjoyable ride."
    },
    {
      "name": "Mumbai to Konkan Darshan Cab",
      description: "Experience the breathtaking beauty of the Konkan coast with AB Ghule Cabs' Konkan Darshan services. Our well-planned travel packages cover all the must-see destinations along the Konkan region, including pristine beaches, historical forts, and picturesque villages. Whether you're a history buff, nature lover, or beach enthusiast, we cater to all interests, making this trip a memorable adventure. Our experienced drivers will ensure a smooth journey, with stops at the most scenic locations, so you can enjoy the beauty of Konkan in comfort."
    },
    {
      "name": "Mumbai to Konkan Innova Cab",
      description: "AB Ghule Cabs offers Innova taxis for your trip to Konkan, providing a spacious and comfortable ride ideal for family trips or group tours. The Innova is perfect for long journeys, ensuring a relaxing experience as you explore the coastal beauty of Konkan. With comfortable seating and ample space, it is well-suited for group travel, allowing you to enjoy the scenic views together. Our experienced drivers are familiar with the best routes, ensuring your trip is both smooth and enjoyable. Trust us for a safe and luxurious ride to Konkan."
    },
    {
      "name": "Mumbai to Konkan Taxi Service",
      description: "Choose AB Ghule Cabs for a reliable and comfortable taxi service to Konkan. Our expert drivers know the best routes and hidden gems along the Konkan coast, ensuring you enjoy a smooth and scenic journey. From the stunning beaches of Alibaug to the historic forts of Sindhudurg, we offer a convenient and enjoyable travel experience that lets you explore all the beautiful destinations Konkan has to offer. Our fleet of well-maintained vehicles ensures that your journey is safe, comfortable, and enjoyable from start to finish."
    },
    {
      "name": "Mumbai to Konkan Darshan Tempo Traveller",
      description: "AB Ghule Cabs offers spacious and comfortable Tempo Traveller services for your Konkan Darshan trip. Whether you're traveling with family or a larger group, our Tempo Travellers provide ample space, comfort, and convenience for everyone. Our well-maintained vehicles are perfect for group tours, with plenty of room for luggage and a comfortable ride for all passengers. Explore the scenic beauty of Konkan, including its beaches, forts, and villages, while enjoying a smooth, hassle-free journey with our professional drivers."
    },
    {
      "name": "Mumbai to Konkan 7 Days Tour Package",
      description: "For a comprehensive and relaxing experience of Konkan, book AB Ghule Cabs' 7-day Konkan tour package. Our package covers a wide range of destinations across Konkan, ensuring you don't miss out on any of the region's most beautiful beaches, forts, and villages. We provide well-maintained vehicles and professional drivers who will ensure a comfortable and stress-free travel experience. From the hustle of Mumbai to the tranquility of Konkan, our tour package is perfect for those looking to explore the Konkan coast at a leisurely pace. Enjoy a mix of sightseeing, relaxation, and adventure!"
    },
    {
      "name": "Mumbai to Konkan Cab Contact Number",
      description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Mumbai to Konkan Cab services. We offer a smooth, enjoyable ride to all our customers, ensuring safety and comfort throughout the journey. Our experienced drivers are dedicated to making your trip to Konkan an unforgettable experience. Whether you're traveling for business, leisure, or a family trip, our reliable services ensure that you reach your destination with ease."
    }
],



tableData: [
    ["-Mumbai to Alibaug Cab", "-Affordable pricing for a comfortable journey to Alibaug from Mumbai"],
    ["-Mumbai to Ratnagiri Cab Service", "-Reliable taxi service for a smooth ride to Ratnagiri"],
    ["-Mumbai to Ganpatipule Taxi Fare", "-Competitive fares for a scenic trip to Ganpatipule"],
    ["-Mumbai to Malvan Cab Service", "-Reliable and professional cab services for Malvan"],
    ["-Mumbai to Tarkarli Cab Booking Online", "-Convenient online booking for your Tarkarli journey"],
    ["-Mumbai to Raigad Cab Booking", "-Affordable taxi services for your visit to Raigad"],
    ["-Mumbai to Deoghar Cabs", "-Comfortable and safe taxi services for your Deoghar trip"],
    ["-Mumbai to Sawantwadi Cab Booking", "-Easy and quick cab booking for your Sawantwadi journey"],
    ["-Mumbai to Konkan Darshan Cab", "-Reliable cab service for a scenic Konkan darshan experience"],
    ["-Mumbai to Konkan Innova Cab", "-Comfortable and spacious Innova cabs for Konkan trips"],
    ["-Mumbai to Konkan Taxi Service", "-Professional taxi services for a safe Konkan travel experience"],
    ["-Mumbai to Konkan Darshan Tempo Traveller", "-Convenient and comfortable tempo traveller services for Konkan darshan"],
    ["-Mumbai to Konkan 7 Days Tour Package", "-All-inclusive tour packages for a memorable 7-day Konkan trip"]
  ],
  
  whychoose: [
    {
      WhyChooseheading: "-Reliable and Professional Service",
      WhyChoosedescription: "At AB Ghule Cabs, we specialize in offering reliable and professional cab services for your Mumbai to Konkan journey. Our experienced drivers are committed to providing you with a safe, comfortable, and enjoyable ride, whether you're heading for a family vacation, business trip, or weekend getaway."
    },
    {
      WhyChooseheading: "-24/7 Availability",
      WhyChoosedescription: "We are available around the clock to serve you. Whether it's a last-minute trip or a well-planned vacation, our team is ready to assist you in booking your cab at any time of the day or night."
    },
    {
      WhyChooseheading: "-Affordable and Transparent Pricing",
      WhyChoosedescription: "We offer competitive pricing with no hidden charges. Whether it’s a one-way or round trip, our transparent fare structure ensures that you know exactly what you’re paying for, providing you with great value for your money."
    },
    {
      WhyChooseheading: "-Clean and Well-Maintained Fleet",
      WhyChoosedescription: "Our fleet consists of clean, well-maintained, and modern vehicles that ensure your comfort and safety. From budget-friendly options to luxury cars, we have a range of vehicles to cater to your travel preferences."
    },
    {
      WhyChooseheading: "-Experienced and Safe Drivers",
      WhyChoosedescription: "All our drivers are highly trained, experienced, and background-checked to ensure you have a safe and smooth journey. Our drivers know the best routes to Konkan, ensuring a timely and hassle-free experience."
    },
    {
      WhyChooseheading: "-Easy Booking Process",
      WhyChoosedescription: "Booking your Mumbai to Konkan cab is simple and fast. You can make your booking online via our website or mobile app, or by calling our customer service helpline, which is available 24/7 to assist you."
    },
    {
      WhyChooseheading: "-Customer Satisfaction Guarantee",
      WhyChoosedescription: "At AB Ghule Cabs, customer satisfaction is our priority. Our dedicated team works hard to ensure that your trip is comfortable, punctual, and enjoyable. We take pride in receiving positive reviews and repeat customers."
    }
  ]
  
  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book a Mumbai to Konkan cab with AB Ghule Cabs?',
      answer: 'You can easily book a cab through our website, mobile app, or by calling our customer service helpline. Our booking process is quick and convenient.',
    },
    {
      id: 'FAQ2',
      question: 'What types of vehicles are available for Mumbai to Konkan cab service?',
      answer: 'We offer a variety of vehicles including sedans, SUVs, and luxury cars to ensure a comfortable and safe ride for all kinds of travelers.',
    },
    {
      id: 'FAQ3',
      question: 'How do I pay for my Mumbai to Konkan cab ride?',
      answer: 'You can pay for your ride through cash, credit/debit cards, or online payment via our mobile app or website, making the payment process hassle-free.',
    },
    {
      id: 'FAQ4',
      question: 'Are your drivers experienced and trustworthy?',
      answer: 'Yes, all of our drivers are highly trained, experienced, and background-checked to provide you with a safe and smooth ride.',
    },
    {
      id: 'FAQ5',
      question: 'Are there any additional charges for detours or waiting time?',
      answer: 'Additional charges may apply for waiting time or detours depending on the specifics of your trip. However, we ensure transparent pricing, and any extra charges will be communicated in advance.',
    },
    {
      id: 'FAQ6',
      question: 'How long does it take to travel from Mumbai to Konkan?',
      answer: 'The journey from Mumbai to Konkan typically takes around 5 to 6 hours, depending on traffic conditions and your final destination in Konkan. Our experienced drivers ensure a smooth and timely journey.',
    },
    {
      id: 'FAQ7',
      question: 'Can I modify or cancel my booking?',
      answer: 'Yes, you can modify or cancel your booking easily via our website or mobile app. If you need assistance, our customer service team is available to help.',
    },
    {
      id: 'FAQ8',
      question: 'Do you offer round-trip services for Mumbai to Konkan?',
      answer: 'Yes, we offer round-trip services to Konkan. You can customize your trip to fit your schedule and preferences.',
    },
    {
      id: 'FAQ9',
      question: 'What makes AB Ghule Cabs different from other Mumbai to Konkan cab services?',
      answer: 'AB Ghule Cabs stands out for its commitment to customer satisfaction, competitive pricing, experienced drivers, well-maintained vehicles, and a hassle-free booking process. We focus on providing a safe, comfortable, and enjoyable journey for every traveler.',
    },
    {
      id: 'FAQ10',
      question: 'Can I book a cab for a group from Mumbai to Konkan?',
      answer: 'Yes, we offer larger vehicles for group travel, ensuring ample space and comfort for your entire group. Please contact our customer service team for group bookings.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: "Mr. Vikas Deshmukh",
      feedback: "I had a fantastic experience with AB Ghule Cabs on my trip to Konkan. The car was clean and well-maintained, and the driver was courteous and professional. We had a smooth and safe journey, and I will definitely choose them for future trips!",
      rating: 5,
    },
    {
      id: 2,
      name: "Ms. Neha Patil",
      feedback: "AB Ghule Cabs made our family trip to Konkan unforgettable. The vehicle was spacious, comfortable, and perfect for our long journey. The driver was friendly and knowledgeable about the routes. Highly recommend their services!",
      rating: 5,
    },
  ];
  
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>

<Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Mumbai to Konkan Taxi | Konkan Cab Service</title>
  <meta name="description" content="Book Mumbai to Konkan cab service for a smooth journey. Affordable taxi fares for destinations like Alibaug, Ratnagiri, Ganpatipule, Malvan, Tarkarli, Raigad, Sawantwadi, and Konkan darshan. Comfortable rides and online cab booking available." />
  <meta name="keywords" content="Mumbai to Alibaug Cab, Mumbai to Ratnagiri Cab Service, Mumbai to Ganpatipule Taxi Fare, Mumbai to Malvan Cab Service, Mumbai to Tarkarli Cab Booking Online, Mumbai to Raigad Cab Booking, Mumbai to Deoghar Cabs, Mumbai to Sawantwadi Cab Booking, Mumbai to Konkan Darshan Cab, Mumbai to Konkan Innova Cab, Mumbai to Konkan Taxi Service, Mumbai to Konkan Darshan Tempo Traveller, Mumbai to Konkan 7 Days Tour Package" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Mumbai to Konkan Taxi | Konkan Cab Service" />
  <meta property="og:description" content="Book Mumbai to Konkan cab service for a smooth journey. Affordable taxi fares for destinations like Alibaug, Ratnagiri, Ganpatipule, Malvan, Tarkarli, Raigad, Sawantwadi, and Konkan darshan. Comfortable rides and online cab booking available." />
  <meta property="og:image" content="https://abghulecabs.com/images/mumbai-to-konkan-cab.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/mumbai-to-konkan-cab" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />
  
  {/* JSON-LD Structured Data for Schema Markup */}
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Mumbai to Konkan Cab Service",
        description: "Book Mumbai to Konkan cab service for a smooth journey. Affordable taxi fares for destinations like Alibaug, Ratnagiri, Ganpatipule, Malvan, Tarkarli, Raigad, Sawantwadi, and Konkan darshan. Comfortable rides and online cab booking available.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Mumbai, Maharashtra",
          "addressLocality": "Mumbai",
          "addressRegion": "Maharashtra",
          "postalCode": "400001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/mumbai-to-konkan-cab",
        "logo": "https://abghulecabs.com/images/mumbai-to-konkan-cab.jpg",
        "image": "https://abghulecabs.com/images/mumbai-to-konkan-cab.jpg",
        "priceRange": "₹4000 - ₹15000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/mumbai-to-konkan-cab",
          "priceCurrency": "INR",
          "price": "4000",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "reviewCount": "1200"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Arun Sharma"
            },
            "datePublished": "2024-11-15",
            "reviewBody": "Fantastic service! The driver was courteous, and the ride to Tarkarli was very comfortable. Highly recommend their Konkan packages."
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Neha Patil"
            },
            "datePublished": "2024-10-30",
            "reviewBody": "Smooth booking process and reliable service. The cab for Konkan Darshan was well-maintained, and the driver was knowledgeable about the routes."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Mumbai to Konkan",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5407",
            "longitude": "73.9600"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/mumbai-to-konkan-cab"
        },
        "keywords": "Mumbai to Alibaug Cab, Mumbai to Ratnagiri Cab Service, Mumbai to Ganpatipule Taxi Fare, Mumbai to Malvan Cab Service, Mumbai to Tarkarli Cab Booking Online, Mumbai to Raigad Cab Booking, Mumbai to Deoghar Cabs, Mumbai to Sawantwadi Cab Booking, Mumbai to Konkan Darshan Cab, Mumbai to Konkan Innova Cab, Mumbai to Konkan Taxi Service, Mumbai to Konkan Darshan Tempo Traveller, Mumbai to Konkan 7 Days Tour Package"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/10.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Mumbaitokonkan;